export type ComputedCSSProps = { [cssPropAttr: string]: string | null };

export type ComputedCSS = {
  [selector: string]: ComputedCSSProps;
};

export const SPACE_REG = /\s+/g;
/** Regexp used to clean up unnecessary spaces */
export const COMMA_SPACE_REG = /\s*,\s*/g;
/** Regexp to find editable css values */
export const CSS_VEV_REG = /^vev\((.*)\)\s*;?$/;
/** Regexp to find vev variables */
export const CSS_VEV_VAR_REG = /\$(primary?\S|accent?\S|bg?\S)/g;
